export default __webpack_public_path__ + "static/media/teams-ui.29ab1c7a.svg";